import { useAppContext } from "../appContext";
import { Element } from "react-scroll";
// Data
import { presentationData } from "../data";
// Components
import { Button, Col, Container, Row } from "react-bootstrap";
import { Title } from "./globalStyledComponents";
import StyledCardPresentation from "./StyledCardPresentation";

export default function Presentations() {
  const { theme } = useAppContext();

  return (
    <Element name={"Presentations"} id="presentations">
      <section className="section">
        <Container className="text-center">
          <Title>
            <h2>Presentations</h2>
            <div className="underline"></div>
          </Title>
          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center row">
                {presentationData.map(function ({
                  id,
                  name,
                  conference,
                  link
                }) {
                  return (
                    <Col key={id}>
                      <StyledCardPresentation
                        name={name}
                        description={conference}
                        url={link}
                      />
                    </Col>
                  );
                })}
              </Row>
        </Container>
      </section>
    </Element>
  );
}
